import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TableColType } from '@shared/enums/table.enum';
import { IActivity } from '@shared/interfaces/activity.interface';
import { IReference } from '@shared/interfaces/reference.interface';
import { ITableCol } from '@shared/interfaces/table.col.interface';
import { Pagination } from '@shared/models/pagination.model';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationReferencesActivitiesService } from '@shared/services/pagination/references/pagination.references.activities.service';
import { Broadcaster } from '@shared/services/action-cable.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sidebar-reference-activities',
    templateUrl: './sidebar.reference.activities.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarReferenceActivitiesComponent implements OnInit, OnDestroy {
  @Input() public reference: IReference;

  public page: Pagination<IActivity>;
  public rows: IActivity[] = [];
  public cols: Partial<ITableCol>[] = [
    {
      headerText: 'TABLES.HEADERS.DATE',
      type: TableColType.Ago,
      selector: 'created_at'
    },
    {
      headerText: 'TABLES.HEADERS.DESCRIPTION',
      type: TableColType.Translatable,
      selector: 'description'
    }
  ];

  private readonly constructorName: string = String(this.constructor.name);
  private readonly channel = String('ReferencesChannel');
  private _broadcastSubscription: Subscription;
  private _paginationSubscription: Subscription;

  constructor(
    private readonly _broadcaster: Broadcaster,
    private readonly _logger: LoggerService,
    private readonly _paginationReferencesActivities: PaginationReferencesActivitiesService
  ) {}

  public get pagination(): PaginationReferencesActivitiesService {
    return this._paginationReferencesActivities;
  }

  ngOnInit(): void {
    this.getActivities();

    this._broadcastSubscription = this._broadcaster.on(this.channel).subscribe((res: any) => {
      if (res.type === 'references_viewed') {
        this._paginationReferencesActivities.reloadPage(
          this._paginationReferencesActivities.currentPage
        );
      }
    });
  }

  ngOnDestroy(): void {
    this._broadcastSubscription?.unsubscribe();
    this._paginationSubscription?.unsubscribe();
  }

  public getActivities() {
    // Set the filter synchronously so <app-pagination>'s ngOnInit requests
    // the first page for the right reference
    this._paginationReferencesActivities.setFilter({
      key: 'referenceId',
      value: this.reference?.id
    });

    const url = `GET /references/${this.reference?.id}/activities`;
    this._paginationSubscription = this._paginationReferencesActivities.page.subscribe(
      (page: Pagination<IActivity>) => {
        this._logger.info(this.constructorName, url, page);

        this.page = page;
        this.rows = page.entries;
      },
      (err: any) => {
        this._logger.error(this.constructorName, url, err);
      }
    );

    this._paginationReferencesActivities.fullReload();
  }
}
